import { useState } from "react";
import { Popover, MenuItem, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";

const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== "danger",
})(({ theme, danger }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  fontSize: "0.875rem",
  padding: theme.spacing(1, 2),
  color: danger ? theme.palette.error.main : "inherit",
  "&:hover": {
    backgroundColor: danger
      ? `${theme.palette.error.main}10`
      : theme.palette.action.hover,
  },
}));

const PopoverContent = styled("div")(({ theme }) => ({
  minWidth: 200,
  padding: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
}));

export function KycActionsPopover({ kyc }) {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleView = () => {
    handleClose();
    navigate(`/kyc/business-kyc/${kyc.merchantId}`);
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            elevation: 2,
            sx: { borderRadius: "8px", mt: 0.5 },
          },
        }}
      >
        <PopoverContent>
          <StyledMenuItem onClick={handleView}>View Details</StyledMenuItem>
        </PopoverContent>
      </Popover>
    </>
  );
}
